import React from "react";
import "./PromoStep.scss";
import girlPromo from "../../images/girl-promo.jpg";
import ButtonSubmit from "../buttonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";

function PromoStep({ text, className, nextStep, onClick }) {
  return (
    <div className="promo__wrapper">
      <div className="user__form-top">
        <h3>Your dream match awaits</h3>
      </div>
      <div className="user__form-content">
        <div className="user__form-image">
          <img src={girlPromo} alt="image_girl" />
        </div>
        <h4>The real deal!</h4>
        <div className="text__wrapper">
          <p>
            Only safe, private, and convenient connections built on mutual
            respect. Ready for next-level matching?
          </p>
        </div>

        <ButtonSubmit
          onClick={() => nextStep()}
          className={"button__global button__promo"}
          text={"Find me a match"}
        />
        <ProgressDots total={6} activeCount={1} />
      </div>
    </div>
  );
}

export default PromoStep;
